import React from "react";
import "./podcast-player.scss";

interface IPodcastPlayerProps {
  id: string;
  className?: string;
  height?: number;
}

const PodcastPlayer = (props: IPodcastPlayerProps) => {
  const compClass = "m-podcastPlayer";
  return (
    <section
      className={`${compClass} ${
        props.className ? props.className : ""
      }`.trim()}
    >
      <div className={`${compClass}__wrapper`}>
        <iframe
          src={`https://open.spotify.com/embed/episode/${props.id}?utm_source=generator&theme=0`}
          width="100%"
          height={props.height || 100}
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
};

export default PodcastPlayer;
